import { useMemo } from 'react';
import useCheckoutState from './useCheckoutState';

export default function useProductPrice() {
  const { page, product, dynamicPrice } = useCheckoutState();

  const productPrice = useMemo(() => {
    if (dynamicPrice) {
      return dynamicPrice;
    }

    return Number(product?.price || 0);
  }, [product, dynamicPrice]);

  if (page.type === 'event') {
    return 0;
  }

  if (!product) {
    return 0;
  }

  return productPrice;
}
